const mobileBreakpoint = 768;
const desktopBreakpoint = 1116;

export default {
  MOBILE: mobileBreakpoint,
  DESKTOP: desktopBreakpoint,
};
